module.exports = __webpack_public_path__ + "img/pp7.56021689.png";